import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private _location: Location) { }

  ngOnInit(): void {
  }

  back(){
    this._location.back();
  }
}
